import React from "react";

const ContactContainer = () => {
  return (
    <>
      <h1>Its Contact Page.</h1>
      
    </>
  );
};

export default ContactContainer;
